import StopScroll from './StopScroll';

class ChangePassword {
  init() {
    this.doc = document;
    this.dialog = this.doc.getElementById('changePasswordDialog');
    this.dialogActiveClass = 'is_active';
    this.closeBtn = this.doc.getElementById('closeBtn');
    this.submitBtn = this.doc.getElementById('submitBtn');
    this.backdrop = this.doc.getElementById('backdrop');
    this.backdropActiveClass = 'is_active';
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.submit = this.submit.bind(this);
    this.stopScroll = new StopScroll();
  }
  start() {
    this.btn = document.getElementById('changePasswordBtn');
    if (!this.btn) return;
    this.init();
    this.btn.addEventListener('click', this.open);
  }
  open() {
    this.dialog.classList.add(this.dialogActiveClass);
    this.backdrop.classList.add(this.backdropActiveClass);
    this.submitBtn.addEventListener('click', this.submit);
    this.backdrop.addEventListener('click', this.close);
    this.closeBtn.addEventListener('click', this.close);
    this.stopScroll.stop();
  }
  close(e) {
    e.preventDefault();
    this.dialog.classList.remove(this.dialogActiveClass);
    this.backdrop.classList.remove(this.backdropActiveClass);
    this.submitBtn.removeEventListener('click', this.submit);
    this.backdrop.removeEventListener('click', this.close);
    this.closeBtn.removeEventListener('click', this.close);
    this.stopScroll.reStart();
  }
  submit(e) {
    this.close(e);
  }
}
export default ChangePassword;



// WEBPACK FOOTER //
// ./src/js/module/ChangePassword.js